import { Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { Divider } from '@sketch-note/design-system/src/components/divider/divider.component';
import {
  ChevronDownIcon,
  HelpIcon,
  LogOutIcon,
  ProfileImageTwoIcon,
  ReloadIcon,
} from '@sketchnote/icons';
import { Avatar } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';
import { useLayout } from 'src/shared/hooks/use-layout';
import { getMemberDetails } from 'src/utils/getMemberDetails';

import {
  Options,
  ProfilePopoverHeader,
  ShowLoggedInInfo,
  ShowOrgs,
  ShowOtherOptions,
} from './profile-popup.component';

export const ProfilePopover = ({ showName = true }: { showName?: boolean }): JSX.Element => {
  const router = useRouter();
  const { useMemo } = React;
  const orgId = router?.query?.orgId;
  const authData = useAuth((s) => s.userDetails);
  const { onChangeOrganisation, onProfileMenu } = useLayout();
  const menuItems = [
    {
      label: 'Account settings & members',
      value: 'settings-member',
      icon: <ProfileImageTwoIcon />,
    },
    {
      label: 'Help Center',
      value: 'Help Center',
      href: '/help',
      icon: <HelpIcon className="text-gray-999" />,
    },
    {
      label: 'Changelog',
      value: 'changelog',
      href: 'https://changelog.sketchnote.co/',
      icon: <ReloadIcon className="text-base text-gray-999 mt-2" />,
    },
  ];
  const menuItemsFooter = [{ label: 'Log out', value: 'log-out', icon: <LogOutIcon /> }];

  const getAllNotification = () => {
    let total_count = 0;
    authData?.organisations?.map((item) => {
      total_count += item?.notificationCount;
    });
    return total_count;
  };

  const currentOrganisation = useMemo(
    () =>
      orgId ? authData?.organisations?.filter((item) => item.organisationId === orgId)[0] : null,
    [router.query.orgId, authData?.organisations]
  );

  return (
    <Popover>
      <PopoverTrigger>
        <button className="border ml-4 rounded-full">
          <div className="m-1.5 max-w-300 text-gray-999 font-medium text-sm rounded-full bg-gray-100 flex py-2 px-6 items-center">
            <Avatar
              wrapperClassName="mt-2"
              name={currentOrganisation?.name || ''}
              size="sm"
              src={currentOrganisation?.avatar || ''}
              type="photo"
              tooltip={false}
            />
            &nbsp;
            {showName ? (
              <span className="block p-4 max-w-223 truncate">{currentOrganisation?.name}</span>
            ) : null}
            <ChevronDownIcon className="ml-10 text-xs  block text-gray-999 mt-2" />
          </div>
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <div
          className="profile-menu-popover shadow-lg w-304 bg-white rounded-lg p-4"
          style={{ maxHeight: '69rem' }}
        >
          <ProfilePopoverHeader
            name={currentOrganisation?.name}
            owner={getMemberDetails(currentOrganisation?.owner_member)?.firstname}
            avatar={currentOrganisation?.avatar}
            email={getMemberDetails(currentOrganisation?.owner_member)?.email}
          />

          <Divider />
          <div className="max-h-400 overflow-y-auto">
            <Options menuItems={menuItems} onClickMenuItem={onProfileMenu} />
            <Divider />
            <ShowOrgs
              organisations={authData?.organisations}
              onClickMenuItem={onChangeOrganisation}
              currentOrganisation={currentOrganisation}
              plan={authData?.plan?.trial ? '' : authData?.plan?.type}
            />

            {/* <ShowAdditionalOrgs
              organizationListMultiple={organizationListMultiple}
              onClickMenuItem={onClickMenuItem}
            /> */}
          </div>
          <Divider />
          <ShowLoggedInInfo
            email={authData?.email}
            name={authData?.name || ''}
            avatar={authData?.avatarUrl || ''}
          />
          <ShowOtherOptions onClickMenuItem={onProfileMenu} menuitems={menuItemsFooter} />
        </div>
      </PopoverContent>
    </Popover>
  );
};
